import axios from 'axios';

const URL = 'https://pixabay.com/api/';
const API_KEY = '55674767-a2ab9f6f3f74198417133d166';

export async function getImagesByQuery(query = '', page = 1) {
  const { data } = await axios(URL, {
    params: {
      key: API_KEY,
      q: query,
      page: page,
      per_page: 15,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: true,
    },
  });
  return data;
}
